import React, { useEffect, useState } from 'react';
import { languages, LanguageType } from './TranslateCountry';

import { IoIosArrowDown } from 'react-icons/io';
import { IconBaseProps } from 'react-icons';

const ActualGoogleTranslate: React.FC = () => {
  const ArrowDownIcon = IoIosArrowDown as unknown as React.FC<IconBaseProps>;

  // 브라우저 언어 감지
  const browserLang = navigator.language || navigator.languages[0];
  const detectedLang = browserLang.split('-')[0]; // 'ko', 'en', 'ja' 등

  // 사용자가 선택한 언어
  const savedLang = localStorage.getItem('preferredLanguage');
  const savedLangObj = savedLang ? JSON.parse(savedLang) : null;

  const [chooseCountry, setChooseCountry] = useState<LanguageType>({
    code: savedLangObj ? savedLangObj.code : detectedLang,
    name: savedLangObj
      ? savedLangObj.name
      : languages.find(lang => lang.code === detectedLang)?.name || '',
    flag: savedLangObj
      ? savedLangObj.flag
      : languages.find(lang => lang.code === detectedLang)?.flag || '',
  });
  const [isOpen, setIsOpen] = useState(false);

  // 브라우저 언어 감지
  const detectBrowserLanguage = (): LanguageType => {
    const browserLang = navigator.language || navigator.languages[0];
    const detectedLang = browserLang.split('-')[0];
    return languages.find(lang => lang.code === detectedLang) || languages[0];
  };

  // localStorage에서 언어 가져오기
  const getSavedLanguage = (): LanguageType | null => {
    try {
      const saved = localStorage.getItem('preferredLanguage');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  };

  // 자동 번역 실행
  const executeAutoTranslation = (targetLang: LanguageType) => {
    if (targetLang.code === 'ko') return;
    setTimeout(() => {
      const gtCombo = document.querySelector<HTMLSelectElement>('.goog-te-combo');
      if (gtCombo) {
        gtCombo.value = targetLang.code;
        gtCombo.dispatchEvent(new Event('change'));
        setChooseCountry(targetLang);
      }
    }, 1500);
  };

  useEffect(() => {
    // 스크립트 중복 로딩 방지
    if ((window as any).googleTranslateLoaded) return;

    const script = document.createElement('script');
    script.src =
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(script);

    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: 'ko',
          autoDisplay: true,
          includedLanguages: languages.map(l => l.code).join(','),
        },
        'google_translate_element'
      );

      const savedLang = getSavedLanguage();
      const targetLang = savedLang || detectBrowserLanguage();
      executeAutoTranslation(targetLang);
    };

    (window as any).googleTranslateLoaded = true;

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleWheel = (e: React.WheelEvent) => e.stopPropagation();

  const handleLanguageChange = (lang: LanguageType) => {
    localStorage.setItem('preferredLanguage', JSON.stringify(lang));
    const gtCombo = document.querySelector<HTMLSelectElement>('.goog-te-combo');
    if (gtCombo) {
      gtCombo.value = lang.code;
      gtCombo.dispatchEvent(new Event('change'));
    }
    setChooseCountry(lang);
  };

  return (
    <>
      <div id="google_translate_element" style={{ display: 'none' }}></div>

      <li className="translate-button" onClick={() => setIsOpen(!isOpen)}>
        <div
          className="flag"
          style={{
            backgroundImage: `url(https://cdn.weglot.com/flags/square/${chooseCountry.flag}.svg)`,
          }}
        />
        <span
          className="arrow"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease',
          }}
        >
          <ArrowDownIcon />
        </span>
        {isOpen && (
          <ul className="language-list" onWheel={handleWheel}>
            {languages.map(lang => (
              <li
                key={lang.code}
                className="language-item"
                onClick={() => handleLanguageChange(lang)}
              >
                <div
                  className="flag"
                  style={{
                    backgroundImage: `url(https://cdn.weglot.com/flags/square/${lang.flag}.svg)`,
                  }}
                />
              </li>
            ))}
          </ul>
        )}
      </li>
    </>
  );
};

// 클라이언트 사이드에서만 렌더링
const GoogleTranslate = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return <ActualGoogleTranslate />;
};

export default GoogleTranslate;
